import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Cuatro = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Organizational Structure</Paragraph>
        <Text className='BaseText2'>We decided to have a <b>centralized organizational structure (decisions are made by top managers) to ensure control over our business process and to include experienced professionals that can foresee long-term effects of the decisions made.</b> We are going to include different departments by work specialization, each one with a team leader. Since we are a small company, communication among departments will be easier than large multinational companies, providing us a competitive advantage over current businesses. The ore we would be able to react quickly to new developments, adapt and improve in an efficient manner</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-20.png'/>
          <p><b> Fig. 3.</b> iMoAge´s Organization to work as a startup. There are 5 main departments in which our operations, marketing, finances, human resources and research and development aspects will be developed.</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Cuatro;
